<template>
  <div
    ref="pointerCompanion"
    class="pointer-companion"
    :class="{hide: !getQueuedElement}"
  >
    <slot>
      <span
        v-if="icon"
        class="pointer-companion__icon"
        :class="icon"
      ></span>
      <span class="pointer-companion__text">Click on canvas to add element.</span>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      iconNames: {
        timer: 'fas fa-stopwatch',
        slideshow: 'fas fa-presentation',
        group: 'fas fa-folder-open',
        'sheet-data': 'fas fa-table',
        'data-list': 'fas fa-list',
        rectangle: 'fas fa-square',
        oval: 'fas fa-circle',
        triangle: 'fas fa-triangle',
        date: 'fas fa-clock',
        text: 'fas fa-text',
        qrcode: 'fas fa-qrcode',
        image: 'fas fa-image',
        'social-data': 'far fa-phone-laptop',
        sportradar: 'fak fa-sportradar',
        'multi-media': 'far fa-photo-video',
        video: 'fas fa-video',
      },
    };
  },
  computed: {
    ...mapGetters('graphicsTemplate', [
      'getQueuedElement',
    ]),
    type() {
      return this.getQueuedElement ? this.getQueuedElement.value.type : null;
    },
    icon() {
      return this.iconNames[this.type];
    },
  },
  watch: {
    getQueuedElement(v) {
      if (v) {
        document.body.style.cursor = 'crosshair';
      } else {
        document.body.style.cursor = 'auto';
      }
    },
  },
  mounted() {
    document.addEventListener('mousemove', this.onMouseMove);
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.onMouseMove);
  },
  methods: {
    onMouseMove(e) {
      if (this.$refs.pointerCompanion) {
        this.$refs.pointerCompanion.style.left = `${e.clientX + 10}px`;
        this.$refs.pointerCompanion.style.top = `${e.clientY + 10}px`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer-companion {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
  &.hide {
    opacity: 0;
    transform: scale(0);
  }

  &__icon {
    font-size: 20px;
  }

  &__text {
    font-size: 14px;
    font-style: italic;
  }
}
</style>
